module.exports = __webpack_public_path__ + "img/activate-admin-info.29223049.webp";